import React, { PropsWithChildren } from 'react'
import { parseErrorMessage } from 'api'
import { createContext } from 'lib/createContext'
import { useRelatedCompumaticPunchesQuery } from 'queries/admin/timeClock/useRelatedCompumaticPunchesQuery'

type RelatedCompumaticPunchesContextState = {
  state: {
    items: NonNullable<
      ReturnType<typeof useRelatedCompumaticPunchesQuery>['data']
    >['items']
    isLoading: boolean
    isError: boolean
    errorMessage: string | undefined
  }
  actions: {
    refetch: ReturnType<typeof useRelatedCompumaticPunchesQuery>['refetch']
  }
}

const [Context, useRelatedCompumaticPunchesContextValue] =
  createContext<RelatedCompumaticPunchesContextState>({
    name: 'RelatedCompumaticPunchesContext',
  })

export const RelatedCompumaticPunchesProvider = ({
  punchId,
  children,
}: PropsWithChildren<{ punchId: number }>) => {
  const { data, isPending, isError, error, refetch } =
    useRelatedCompumaticPunchesQuery(punchId)

  const value: RelatedCompumaticPunchesContextState = {
    state: {
      items: data?.items ?? [],
      isLoading: isPending,
      isError,
      errorMessage: parseErrorMessage(error),
    },
    actions: { refetch },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useRelatedCompumaticPunchesContextValue }
